import { render, staticRenderFns } from "./Alevtina.vue?vue&type=template&id=2726840c&scoped=true"
import script from "./Alevtina.vue?vue&type=script&lang=ts"
export * from "./Alevtina.vue?vue&type=script&lang=ts"
import style0 from "./Alevtina.vue?vue&type=style&index=0&id=2726840c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726840c",
  null
  
)

export default component.exports